import React from 'react';
import { useLocation } from 'react-router-dom';

// Blendet Header/Footer/Banner auf dem eigenständigen Check-in-Link (/checkin) aus,
// damit auf dem Kassen-/Check-in-Tablet nur die Check-in-Seite sichtbar ist.
export default function SiteChrome({ children }) {
  const location = useLocation();
  if (location.pathname === '/checkin') return null;
  if (location.pathname.startsWith('/scripturia')) return null;
  if (location.pathname === '/bibelstudium') return null;
  if (location.pathname === '/willkommen') return null;
  return <>{children}</>;
}
